import useOffersStuff from './useOffersStuff';
import { OfferKindEnum, OfferTypeEnum } from '../../../services/exports/Constants';
import { selectHasCachedOrderPromoCode } from '../../../store/slices/OrderSlice';
import { useSelector } from 'react-redux';
import useGetMenuOfferHandlerByKind from './get-offer-handler/useGetMenuOfferHandlerByKind';

const useFreeItemOffer = () => {
  const hasPromoCode = useSelector(selectHasCachedOrderPromoCode);
  const { activeOffers, appliedOffers, unlockedOffers } = useOffersStuff();
  const freeItemOffer = activeOffers?.find((offer) => offer.type === OfferTypeEnum.FreeItem);
  const isFreeItemByMinSpendValid =
    unlockedOffers.some((offer) => offer.kind === OfferKindEnum.FreeItemByMinSpendValue) &&
    (!appliedOffers?.every || appliedOffers.every((appliedOffer) => appliedOffer.type !== OfferTypeEnum.FreeItem));
  const isFreeItemByProductsValid = freeItemOffer?.kind === OfferKindEnum.FreeItemByProducts;
  const productOfferStuff = useGetMenuOfferHandlerByKind()(freeItemOffer);

  if (hasPromoCode) {
    return;
  }

  if (!isFreeItemByMinSpendValid && !isFreeItemByProductsValid) {
    return;
  }

  return {
    offer: freeItemOffer,
    ...productOfferStuff,
  };
};

export default useFreeItemOffer;
